import React from "react"

// antd
import { Tag, Typography, Button, message, Space } from "antd"
import { SmileFilled, LogoutOutlined } from "@ant-design/icons"

// firebase
import { Auth } from "services/firebase"
import { signOut } from "firebase/auth"

// store
import { useAuth } from "store/auth"

// i18n
import { useTranslation } from "react-i18next"

const UserInfo = ({ onLogout = () => null }) => {
  const { isAuthentificated, user } = useAuth()
  const { t } = useTranslation()
  const [messageApi, contextHolder] = message.useMessage()

  if (!isAuthentificated) return null

  return (
    <div>
      {contextHolder}

      <Tag color="purple" icon={<SmileFilled style={{ fontSize: 14 }} />}>
        <Space>
          <Typography.Text>{t("logged_in_as")}</Typography.Text>
          {user.isAnonymous ? (
            <Typography.Text strong>{t("guest")}</Typography.Text>
          ) : user?.data?.firstname && user?.data?.familyname ? (
            <Typography.Text strong>
              {user.data.firstname} {user.data.familyname}
            </Typography.Text>
          ) : (
            <Typography.Text strong>{user.email}</Typography.Text>
          )}
        </Space>
      </Tag>

      <Button
        size="small"
        type="dashed"
        icon={<LogoutOutlined />}
        onClick={() => {
          signOut(Auth)
            .then(() => {
              onLogout()
              messageApi.success(t("signed_out"))
            })
            .catch((e) => messageApi.error(e.message))
        }}
      >
        {t("sign_out")}
      </Button>
    </div>
  )
}

export default UserInfo
